export enum ProfileTab {
  GENERAL = 'general',
  ACTIVITY_ITEMS = 'activity-items',
  RELATED = 'related',
  SOWS_RELATED = 'sows-related',
  WORKERS_RELATED = 'workers-related',
  WORKERS_LIST = 'workers-list',
  NEW_WORKER = 'new-worker',
  EQUIPMENTS_LIST = 'equipments-list',
  NEW_EQUIPMENTS = 'new-equipments',
  SOWS = 'sows',
  WORKERS = 'workers',
  EQUIPMENTS = 'equipments',
}
